import { produce } from 'immer';
import { EffectReducer } from 'use-effect-reducer';
import {
  EffectSingleDateRangePicker,
  EventSingleDateRangePicker,
  StateSingleDateRangePicker
} from './types';
import { commmonReducer } from './commonReducer';

export const dateRangeReducer: EffectReducer<
  StateSingleDateRangePicker,
  EventSingleDateRangePicker,
  EffectSingleDateRangePicker
> = (state, action, exec) =>
  produce<StateSingleDateRangePicker, StateSingleDateRangePicker>(state, (draft) => {
    //  console.log('action', action);

    switch (action.type) {
      case 'SET_DATE_ACTION':
        if (
          // TODO: remove activeTab check, not needed
          (draft.activeTab === 'exact' || draft.activeTab === 'flexible') &&
          state.monthsInterval?.startMonth === undefined &&
          state.tripDuration?.minimum === undefined
        ) {
          if (action.payload) {
            draft.preSelected = action.payload;
            draft.displayDate = action.payload;
            if (action.component === 'start') {
              draft.currentDate = { ...draft.currentDate, start: action.payload };
              draft.selectedRange = { ...draft.selectedRange, start: action.payload };
              draft.valid = true;
            } else if (action.component === 'end') {
              draft.currentDate = { ...draft.currentDate, end: action.payload };
              draft.selectedRange = { ...draft.selectedRange, end: action.payload };
              draft.validEnd = true;
            }
          } else {
            draft.selectedRange = { ...draft.currentDate, end: undefined };
            draft.currentDate = { ...draft.currentDate, end: undefined };
            draft.valid = true;
          }
          draft.focusSelectedDay = false;
        }
        exec(action);
        break;
      case 'SELECT_DAY_ACTION':
        if (state.selectedComponent === 'start') {
          if (action.payload.start) {
            // if (!draft.enableFlexibleDates)
            //   draft.currentDate = { ...draft.currentDate, start: action.payload.start };
            draft.selectedRange = { ...draft.selectedRange, start: action.payload.start };
          } else {
            // if (!draft.enableFlexibleDates)
            //   draft.currentDate = { ...draft.currentDate, end: action.payload.end };
            draft.selectedRange = { ...draft.selectedRange, end: action.payload.end };
          }
        } else {
          if (action.payload.start && action.payload.end) {
            // if (!draft.enableFlexibleDates)
            //   draft.currentDate = { start: action.payload.start, end: action.payload.end };
            draft.selectedRange = { start: action.payload.start, end: action.payload.end };
          } else if (action.payload.start) {
            // if (!draft.enableFlexibleDates)
            //   draft.currentDate = { ...draft.currentDate, start: action.payload.start };
            draft.selectedRange = { ...draft.selectedRange, start: action.payload.start };
          } else {
            // if (!draft.enableFlexibleDates)
            //   draft.currentDate = { ...draft.currentDate, end: action.payload.end };
            draft.selectedRange = { ...draft.selectedRange, end: action.payload.end };
          }
        }
        draft.tripDuration = undefined;
        draft.monthsInterval = {};
        draft.valid = true;
        draft.validEnd = true;
        exec(action);
        break;
      case 'CLEAR_ACTION':
        draft.isCheckedFlexibleDates = false;
        draft.preSelected = undefined;
        draft.currentDate = {};
        draft.monthsInterval = {};
        if (draft.selectedComponent === 'start') {
          draft.inputValue = {};
          draft.currentDate = {};
          draft.selectedRange = {};
        } else {
          draft.inputValue = { end: undefined, start: state.inputValue?.start };
          draft.currentDate = { end: undefined, start: state.currentDate?.start };
          draft.selectedRange = { end: undefined, start: state.selectedRange.start };
        }
        draft.focusSelectedDay = false;
        // draft.selectedComponent = 'start';
        draft.monthsInterval = {};
        draft.tripDuration = undefined;
        draft.valid = true;
        draft.validEnd = true;
        exec(action);
        break;
      case 'UNDO_ACTION':
        draft.inputValue = { start: '', end: '' };
        draft.preSelected = undefined;
        draft.selectedRange = state.currentDate !== null ? state.currentDate : {};
        draft.focusSelectedDay = false;
        draft.valid = true;
        draft.validEnd = true;
        exec(action);
        break;
      case 'RESET_DATA_ACTION':
        draft.isCheckedFlexibleDates = false;
        draft.inputValue = { start: '', end: '' };
        draft.selectedRange = {};
        draft.preSelected = undefined;
        draft.currentDate = null;
        draft.focusSelectedDay = false;
        draft.monthsInterval = {};
        draft.tripDuration = undefined;
        draft.valid = true;
        break;
      case 'SET_VALID_END':
        draft.validEnd = action.payload;
        break;
      case 'SET_TYPE_ERROR_END':
        draft.typeErrorEnd = action.payload;
        break;
      case 'MIN_TRIP_DURATION_DAYS': {
        draft.blackoutDays = action.payload;
        break;
      }
      default:
        commmonReducer(draft, action, exec);
    }
  });
